module.exports = __webpack_public_path__ + "img/sytp.45d25600.png";